
import React from 'react';
import { Business } from '@/schemas/business';
import { 
  DropdownMenu, 
  DropdownMenuContent
} from "@/components/ui/dropdown-menu";
import { BusinessesList } from './BusinessesList';
import { AllBusinessesItem } from './AllBusinessesItem';
import { BusinessSelectorTrigger } from './BusinessSelectorTrigger';
import { useBusinessSelector } from './hooks/useBusinessSelector';
import { useFirebase } from '@/context/FirebaseProvider'; // Import useFirebase

interface BusinessSelectorProps {
  businessName?: string;
  // allBusinesses prop removed
  onBusinessSelect?: (id: string) => void;
  navigate?: ((id: string) => void) | ((to: string) => void);
  hideAllBusinessesOption?: boolean;
  isMobile?: boolean;
}

export const BusinessSelector: React.FC<BusinessSelectorProps> = ({
  businessName,
  // allBusinesses prop removed from destructuring
  onBusinessSelect,
  hideAllBusinessesOption = false,
  isMobile = false
}) => {
  const { businesses: allBusinessesFromFirebase, isLoading: isLoadingBusinesses } = useFirebase(); // Get businesses from useFirebase

  const {
    currentBusiness,
    triggerRef,
    triggerWidth,
    handleNavigation,
    handleAllBusinessesNavigation,
    hideAllBusinessesOption: shouldHideAllBusinessesOption
  } = useBusinessSelector({ // allBusinesses argument removed
    businessName,
    onBusinessSelect,
    hideAllBusinessesOption
  });

  // Handle loading state for businesses
  // Always render DropdownMenu, but content can be conditional or trigger can be disabled/show loading
  return (
    <DropdownMenu>
      <div ref={triggerRef}>
        <BusinessSelectorTrigger 
          business={isLoadingBusinesses ? undefined : currentBusiness} 
          businessName={isLoadingBusinesses ? "Loading..." : (currentBusiness?.displayName || currentBusiness?.name || businessName)} 
          isMobile={isMobile}
        />
      </div>
      
      {!isLoadingBusinesses && (
        <DropdownMenuContent 
          align="start" 
          style={{ width: `${triggerWidth}px` }}
          className="bg-white"
        >
          <AllBusinessesItem 
            onClick={handleAllBusinessesNavigation}
            hide={shouldHideAllBusinessesOption}
          />
          
          <BusinessesList 
            businesses={allBusinessesFromFirebase || []} // Use businesses from useFirebase
            onBusinessSelect={handleNavigation} 
          />
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
};
